import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, DropdownButton, Form, Row } from "react-bootstrap";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import { useSearchParams } from "react-router-dom";
import { userSubscriptionPageRequest, userUpdateSubscriptionState } from "../../api/adminApi";
import { getSubscriptionType } from "../../api/userApi";
import { dispatchAlertError, dispatchAlertSuc } from "../../app/godispatch";
import { makeid } from "../../app/utils";
import AdminLayout from "../component/AdminLayout";
import Loading from "../component/Loading";
import ShowPagination from "../component/ShowPagination";
import AddSubscriptionPage from "./AddSubscriptionPage";
import './AdminUserPage.css';

export default function AdminUserSubscriptionPage() {
    document.title = '用户订阅管理'
    const [sp] = useSearchParams();
    const userInfo = {
        username: sp.get('username'),
        name: sp.get('name'),
    }
    const [searchParam, setSearchParam] = useState({
        username: userInfo.username,
        type: null,
        pageNo: 0,
        pageSize: 10
    });
    const [currentSearchParam, setCurrentSearchParam] = useState(searchParam)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState(null)
    const [subTypes, setSubTypes] = useState([])
    const addUserSubscriptionPageRef = useRef(null)


    const search = (pageNo, newSearchParam) => {
        setLoading(true)
        if (!pageNo) {
            pageNo = 0;
        }
        let param
        if (newSearchParam) {
            param = { ...newSearchParam, pageNo: pageNo }
        } else {
            param = { ...currentSearchParam, pageNo: pageNo }
        }

        userSubscriptionPageRequest(param)
            .then(result => {
                if (result.data) {
                    setData(result.data)
                }
            })
            .catch(err => { dispatchAlertError(err) })
            .finally(() => { setLoading(false) })
    }

    const fillTypeSelect = () => {
        getSubscriptionType()
            .then(result => {
                if (result.data) {
                    let r = []
                    for (var type in result.data) {
                        r.push(<option key={type} value={type}>{result.data[type]}</option>)
                    }
                    setSubTypes(r)
                }
            })
            .catch(err => { dispatchAlertError('获取订阅类型失败') })
    }

    useEffect(() => {
        fillTypeSelect()
        clickSearch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const clickSearch = () => {
        setCurrentSearchParam({ ...searchParam })
        search(0, searchParam)
    }

    const subscriptionStateChange = (id, valid) => {
        let text = '是否确认' + (valid ? '启用' : '停用') + '该订阅？'
        if (window.confirm(text)) {
            setLoading(true)
            userUpdateSubscriptionState({ id, valid })
                .then(() => {
                    dispatchAlertSuc('更新成功')
                    search()
                })
                .catch(err => { dispatchAlertError(err) })
                .finally(() => setLoading(false))
        }
    }

    return (
        <AdminLayout>
            <Container fluid>
                <Row xs={2} md={4} className="searchArea">
                    <Col xs={6}>
                        <Form.Group>
                            <Form.Label>用户名</Form.Label>
                            <Form.Control value={userInfo.username} disabled />
                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <Form.Group>
                            <Form.Label>姓名</Form.Label>
                            <Form.Control value={userInfo.name} disabled />
                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <Form.Label>单页显示条数</Form.Label>
                        <Form.Select aria-label="select"
                            onChange={e => setSearchParam(prevState => ({
                                ...prevState,
                                pageSize: parseInt(e.target.value)
                            }))}>
                            <option key={10} value={10}>10</option>
                            <option key={20} value={20}>20</option>
                            <option key={50} value={50}>50</option>
                        </Form.Select>
                    </Col>
                    <Col xs={6}>
                        <Form.Group>
                            <Form.Label>订阅类型</Form.Label>
                            <Form.Select aria-label="Default select example"
                                onChange={e => setSearchParam(prevState => ({
                                    ...prevState,
                                    type: e.target.value === "" ? null : e.target.value
                                }))}>
                                <option key={2} value={""}>所有</option>
                                {subTypes}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-end searchArea">
                    <Col xs={4} md={2} className='d-flex justify-content-center align-items-center'>
                        <Button variant="warning" size="md" onClick={() => addUserSubscriptionPageRef.current.showMe(userInfo, subTypes)} disabled={loading}>新增订阅</Button>
                    </Col>
                    <Col xs={4} md={2} className='d-flex justify-content-center align-items-center'>
                        <Button variant="primary" size="md" onClick={() => clickSearch()} disabled={loading}>搜索</Button>
                    </Col>
                </Row>
                <Row className="resultArea">
                    {loading && <Loading />}
                    {!loading && data &&
                        <Container>
                            <Row>
                                <Col style={{ marginBottom: '1em', borderBottom: '1px solid' }}>
                                    当前显示第{data.number + 1}页 总计{data.totalPages}页 共{data.totalElements}条订阅
                                </Col>
                            </Row>
                            <Row xs={6} md={6} className="myRow">
                                <Col xs={1} className="myCell d-flex justify-content-center align-items-center"><strong>序号</strong></Col>
                                <Col xs={3} className="myCell d-flex justify-content-center align-items-center"><strong>类型</strong></Col>
                                <Col xs={3} className="myCell d-flex justify-content-center align-items-center"><strong>开始日期</strong></Col>
                                <Col xs={3} className="myCell d-flex justify-content-center align-items-center"><strong>结束日期</strong></Col>
                                <Col xs={1} className="myCell d-flex justify-content-center align-items-center"><strong>状态</strong></Col>
                                <Col xs={1} className="myCell d-flex justify-content-center align-items-center"><strong>操作</strong></Col>
                            </Row>
                            {
                                data.content.map((item, index) => {
                                    return (
                                        <Row xs={6} md={6} key={makeid(5)} className="myRow">
                                            <Col xs={1} className="text-break myCell d-flex justify-content-center align-items-center">{data.number * data.size + index + 1}</Col>
                                            <Col xs={3} className="text-break myCell d-flex justify-content-center align-items-center">{item.type}</Col>
                                            <Col xs={3} className="text-break myCell d-flex justify-content-center align-items-center">{moment.utc(item.createTime).local().format('YYYY-MM-DD')}</Col>
                                            <Col xs={3} className="text-break myCell d-flex justify-content-center align-items-center">{moment.utc(item.expireTime).local().format('YYYY-MM-DD')}</Col>
                                            <Col xs={1} className="text-break myCell d-flex justify-content-center align-items-center">
                                                {item.valid ? <span>&#9989;</span> : <span>&#10060;</span>}
                                            </Col>
                                            <Col xs={1} className="text-break myCell d-flex justify-content-center align-items-center">
                                                <DropdownButton variant="outline-secondary" className="dropdownBtnStyle"
                                                    title="+"
                                                    size="sm" >
                                                    {item.valid ?
                                                        <DropdownItem className="dropdownItemStyle" style={{ color: 'red' }} disabled={loading}
                                                            onClick={() => subscriptionStateChange(item.id, false)}>停用</DropdownItem>
                                                        :
                                                        <DropdownItem className="dropdownItemStyle" style={{ color: 'green' }} disabled={loading}
                                                            onClick={() => subscriptionStateChange(item.id, true)}>启用</DropdownItem>
                                                    }
                                                </DropdownButton>
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                        </Container>
                    }
                </Row>
                <Row className="pageArea">
                    <Col className='d-flex justify-content-center align-items-center'>
                        {!loading && data &&
                            <ShowPagination data={data} jumpFunction={search} />
                        }
                    </Col>
                </Row>
            </Container>
            <AddSubscriptionPage ref={addUserSubscriptionPageRef} />
        </AdminLayout>
    )
}